/**
 * Application version utilities
 * Reads version from package.json to avoid hardcoding
 */

// Import the entire package.json as default export
import packageJson from "../../package.json";

export const APP_VERSION = packageJson.version;

/**
 * Get the full version string with 'v' prefix
 * @returns {string} Version string (e.g., "v0.1.0")
 */
export const getVersionString = () => `v${packageJson.version}`;

export default APP_VERSION;
